Apt.fn.make('truncate', {
	/**
	 * Initialize module
	 *
	 * @param {$} target
	 * @returns {Object}
	 */
	init(target) {
		const scope = this;

		if (window.crawler) {
			return scope;
		}

		const priv = scope.$private;
		const $target = $(target);

		priv.conf = {
			content: $target[0].innerHTML,
			label: $target[0].dataset.label || 'Show more',
			limit: $target[0].dataset.limit || (
				$.screen.size() < 3 ?
					180 : 260
			),
			namespace: LS.util.uid(),
			$target: $target
		};

		priv.setup();

		return scope;
	},

	/**
	 * Destroy module
	 *
	 * @private
	 */
	_destruct() {
		const conf = this.$private.conf;

		if (conf) {
			$.events.reset(conf.namespace);
		}
	}
}, {
	/**
	 * Truncate initial text
	 */
	setup() {
		const conf = this.conf;

		if (conf.$target.height() <= (conf.limit * 1.2) + 80) {
			return;
		}

		const $wrapper = $(`<div class="truncated" style="max-height:${conf.limit}px"/>`);

		$wrapper.append(conf.$target.children());

		conf.$target.append($wrapper);

		const $more = $('<button class="-plain truncated__more">' + conf.label + '</button>');

		$more.on('mousedown', () => {
			conf.$target.html($wrapper[0].innerHTML);
		}, {
			namespace: conf.namespace
		});

		conf.$target.append($more);
	}
});